import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { AiOutlineLike } from "react-icons/ai";
import { BiDislike } from "react-icons/bi";
import { FaUserCircle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import useAuthUser from "../../../auth/getUser";

const SingleBlog = () => {
  const [blog, setBlog] = useState({});
  const { id } = useParams();
  const [commentInput, setComment] = useState("");
  const [loader, setLoader] = useState(1);
  const {user} = useAuthUser();
  // console.log("this is auth user", user)

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const comment = {
      user: user._id,
       message: commentInput
    }
    // console.log( "this is comment", {comment, commentInput})
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_API}/blogs/comment/${id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(comment),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to add comment");
      }
      const updatedBlog = await response.json();
      setLoader(loader + 1);
      setComment("")
      // console.log("Comment added:", updatedBlog);
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_API}/blogs/${id}`
        );
        setBlog(res.data);
      } catch (error) {
        console.error("There was an error fetching the blog!", error);
        Swal.fire({
          title: "Error!",
          text: "There was an error fetching the blog",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    fetchBlog();
  }, [loader]);

  const handleLike = async (id, name) => {
    // Check if the post is already liked or disliked
    const status = localStorage.getItem(id);
  
    if (status === 'liked' || status === 'disliked') {
      // console.log(`Post is already ${status}`);
      return; // Exit if already liked or disliked
    }
  
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_BASE_API}/blogs/comment/${id}?${name}=true`
      );
      console.log(res.data);
  
      // Update the local storage to reflect the like status
      localStorage.setItem(id, 'liked'); // or 'disliked' based on your requirement
  
      setLoader(loader + 1); 
    } catch (error) {
      console.log(error);
    }
  };
  
  // console.log(blog.comments)

  return (
    <div className="max-w-4xl mx-auto">
      <h2 className="text-3xl font-semibold capitalize">{blog.headline}</h2>
      <div className="flex gap-4 items-center mt-2">
        <h2 className="flex gap-2 items-center">
          <FaUserCircle />{" "}
          <span className="text-blue-500">{blog?.createdby}</span>
        </h2>
        <h2>
          <h3 className="text-[12px]">
            {moment(blog.createdAt).format("MMMM Do YYYY, h:mm a")}
          </h3>
        </h2>
      </div>
      <div className="mt-3 mb-3 prose">
        <h2 className=" font-normal" dangerouslySetInnerHTML={{ __html: blog.description }} />
      </div>

      <hr className="border border-base-200" />
      <div className="flex gap-3 mb-3 mt-5">
        <div
          onClick={() => handleLike(blog._id,"like")}
          className="bg-green-300 flex gap-1 items-center px-4 py-1 rounded-lg border-2 border-green-500 hover:cursor-pointer active:opacity-30"
        >
          <AiOutlineLike className="text-2xl text-green-700" />{" "}
          <span>{blog.like ? blog.like : 0}</span>
        </div>
        <div
          onClick={() => handleLike("dislike")}
          className="bg-red-300 flex gap-1 items-center px-4 py-1 rounded-lg border-2 border-red-500 hover:cursor-pointer active:opacity-30"
        >
          <BiDislike className="text-2xl text-red-700" />{" "}
          <span>{blog.dislike ? blog.dislike : 0}</span>
        </div>
        <form onSubmit={handleSubmit} className=" flex gap-x-5">
          <input
            type="text"
            placeholder="Write your comment"
            value={commentInput}
            onChange={handleCommentChange}
            className="input input-bordered w-full max-w-xs"
          />
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </form>
      </div>
      <div className=" grid grid-cols-1 gap-y-10 my-10">
        {blog?.comments?.slice().reverse().map(item =>
          <div className=" flex gap-x-5 items-center">
            <img 
            src={item.user.image} 
            className=" w-10 h-10 rounded-full"
            alt="User profile"
            />
            <div className="">
              <h5 className=" text-sm font-semibold">{item.user.name}</h5>
              <p className=" text-sm font-normal">{item.message}</p>
            </div>
          </div>
        )}
        {/* <div>
          <Image

        </div> */}
      </div>
    </div>
  );
};

export default SingleBlog;
